import { render } from "./StepAnagrafica.vue?vue&type=template&id=1526a4d4&scoped=true"
import script from "./StepAnagrafica.vue?vue&type=script&lang=js"
export * from "./StepAnagrafica.vue?vue&type=script&lang=js"

import "./StepAnagrafica.vue?vue&type=style&index=0&id=1526a4d4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1526a4d4"]])

export default __exports__